import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Collapse, CardBody, Card } from 'reactstrap';

class EirDropdownInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      items: ["€99.99", "€99.99", "12 mths","€99.99", "€99.99"],
    };
  }

  toggle = () => {
    this.setState({
      collapse: !this.state.collapse
    });
  };

 
  render() {
    
    let dropDownHeight = 0;
    //dropDownHeight = ((this.props.dropDownInfo.length * 16) + 32) + "px"
    dropDownHeight = ((this.props.maxDropDownLines * 16) + 32) + "px"

    let feeType = [];
    let feePrice = [];
    this.props.dropDownInfo.map((line, index) => {
      let fees = line.split(":");
      feeType.push(fees[0]);
      feePrice.push(fees[1]);
    });

    const chevronStyle = {
      verticalAlign: "-1px",
      width: "1rem",
      height: "1rem",
    }
    let chevron;
    if (!this.state.collapse) {
      chevron = <span className='ml-1 sort-icon eir-icon icon-arrowdown--purple' onClick={this.toggle} style={ chevronStyle} />;
    } else {
      
      chevron = <span className='ml-1 sort-icon eir-icon icon-arrowup--purple' onClick={this.toggle} style={ chevronStyle} />;
    }

    return (
      
      <Container className="text-center">
        <Row className="justify-content-center text-nowrap" noGutters>
          <div className="m-0 p-0">
            <span color="primary" onClick={this.toggle} style={{ paddingBottom: '1rem' }}>
              <h6><u>{this.state.collapse ?  this.props.titleOpen : this.props.titleClosed}</u></h6>
            </span>
          </div>
          <div className="m-0 p-0">
            {chevron}
          </div>
        </Row>
        <Row>  
          <Collapse className="moredetails-collapse-width pb-2" isOpen={this.state.collapse} style={{height: dropDownHeight}}>
            <Row>
              <Col className="more-details-feature pr-0 m-0" xs="8">
                {feeType.map((line, index) => (
                  <div>{line}</div>
                ))}
              </Col>
            
              <Col className="more-details-feature pl-0 m-0" xs="4">
                  {feePrice.map((item, index) => (
                      <div key={index}>{item}</div>
                  ))}
              </Col>
              
            </Row>
          </Collapse>
        </Row>
    </Container>
    );
  }
}

export default EirDropdownInfo;
